var map = {
	"./abstract01.webp": 2332,
	"./abstract010.webp": 2333,
	"./abstract02.webp": 2334,
	"./abstract03.webp": 2335,
	"./abstract05.webp": 2336,
	"./abstract06.webp": 2337,
	"./abstract07.webp": 2338,
	"./big_head_-1.webp": 2339,
	"./big_head_-10.webp": 2340,
	"./big_head_-2.webp": 2341,
	"./big_head_-3.webp": 2342,
	"./big_head_-5.webp": 2343,
	"./big_head_-6.webp": 2344,
	"./big_head_-7.webp": 2345,
	"./small_head_-1.webp": 2346,
	"./small_head_-10.webp": 2347,
	"./small_head_-2.webp": 2348,
	"./small_head_-3.webp": 2349,
	"./small_head_-5.webp": 2350,
	"./small_head_-6.webp": 2351,
	"./small_head_-7.webp": 2352,
	"./sponsor-banner-cn-m.webp": 2353,
	"./sponsor-banner-cn.webp": 2354,
	"./sponsor-banner-id-m.webp": 2355,
	"./sponsor-banner-id.webp": 2356,
	"./sponsor-banner-m.webp": 2357,
	"./sponsor-banner-ms-m.webp": 2358,
	"./sponsor-banner-ms.webp": 2359,
	"./sponsor-banner.webp": 2360,
	"./sponsor-bg-1-cn.webp": 2361,
	"./sponsor-bg-1-id.webp": 2362,
	"./sponsor-bg-1-ms.webp": 2363,
	"./sponsor-bg-1.webp": 2364,
	"./sponsor-bg-2-cn.webp": 2365,
	"./sponsor-bg-2-id.webp": 2366,
	"./sponsor-bg-2-ms.webp": 2367,
	"./sponsor-bg-2.webp": 2368,
	"./sponsor-bg-m-2-cn.webp": 2369,
	"./sponsor-bg-m-2-id.webp": 2370,
	"./sponsor-bg-m-2-ms.webp": 2371,
	"./sponsor-bg-m-2.webp": 2372,
	"./sponsor-video-one.mp4": 2373
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2331;